import { Component, Input } from '@angular/core';
import { AllegationsAdditionalInfoCase } from './../../allegations-additional-info';
import { ContemptMotion } from './../../../../../juvenile/juvenile-case-sections/contempt-motion';

@Component({
  selector: 'app-dispostioin-contempt-motion',
  templateUrl: './disposition-contempt-motion.component.html',
  styleUrls: ['./../../../juvenile-case-view.component.less']
})
export class DispositionContemptMotionComponent {
  relatedAllegationsFlag: boolean;

@Input() contemptMotion: ContemptMotion;

  constructor() { 
    this.relatedAllegationsFlag = false;
  }

getRelatedAllegationsFlag(): boolean {
    return this.relatedAllegationsFlag;
}

showReleatedAllegations() {
    this.relatedAllegationsFlag = true;
}

hideReleatedAllegations() {
    this.relatedAllegationsFlag = false;
}

}


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/allegations/allegations-additional-info/contempt-motion/disposition-contempt-motion.component.ts